/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SalaryRangeAnalysisPointStatus {
    BELOW = 'below',
    WITHIN = 'within',
    ABOVE = 'above',
}
